import { usePageSEO } from "@/lib/use-page-seo";
import { useSearch } from "wouter";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { useLocalePath } from "@/lib/use-locale-path";

export default function UnsubscribedPage() {
  usePageSEO("meta.unsubscribed_title", "/unsubscribed");
  const { t } = useTranslation();
  const lp = useLocalePath();
  const searchString = useSearch();
  const params = new URLSearchParams(searchString);
  const status = params.get("status");

  return (
    <div className="min-h-screen bg-[#0a0a0a] px-4">
      <header className="flex justify-end py-4 max-w-md mx-auto">
        <LanguageSwitcher />
      </header>
      <div className="flex items-center justify-center min-h-[calc(100vh-4rem)]">
      <div className="max-w-md w-full text-center">
        {status === "success" ? (
          <>
            <h1 className="text-2xl font-bold text-white mb-4">{t("unsubscribed.success_heading")}</h1>
            <p className="text-gray-400 text-[15px] leading-relaxed">
              {t("unsubscribed.success_body")}
            </p>
          </>
        ) : (
          <>
            <h1 className="text-2xl font-bold text-white mb-4">{t("unsubscribed.error_heading")}</h1>
            <p className="text-gray-400 text-[15px] leading-relaxed">
              {t("unsubscribed.error_body")}
            </p>
          </>
        )}
        <a
          href={lp("/")}
          className="inline-block mt-8 text-sm text-gray-500 hover:text-white transition-colors"
        >
          {t("unsubscribed.back")}
        </a>
      </div>
      </div>
    </div>
  );
}
